// extracted by mini-css-extract-plugin
module.exports = {"base":"DynamicIcon_base__1YUOi"};